import React, { useContext, useState } from 'react';
import { CategoryContext } from '../context/CategoryContext';
import { RecipeContext } from '../context/RecipeContext';

const Form = () => {

    const [ search, setSearch ] = useState({
        name: '',
        category: ''
    });

    const { categories } = useContext( CategoryContext );
    const { setSearchRecipe, setConsult } = useContext( RecipeContext );

    const getRecipeData = e => {
        setSearch({
            ...search,
            [e.target.name] : e.target.value
        })
    }
    
    return ( 
        <form
            className="col-12"
            onSubmit={ e => {
                e.preventDefault();
                setSearchRecipe(search);
                setConsult(true);
            }}
        >
            <fieldset className="text-center">
                <legend>Find a drink by category or ingredient</legend>
            </fieldset>
            <div className="row mt-4">
                <div className="col-md-4">
                    <input 
                        name="name"
                        className="form-control"
                        placeholder="Find by ingredient, e.g: Tequila"
                        onChange={ getRecipeData }
                    />
                </div>
                <div className="col-md-4">
                    <select
                        className="form-control"
                        name="category"
                        onChange={ getRecipeData }
                    >
                        <option value="">- Select a category -</option>
                        {
                            categories.map( category => (
                                <option 
                                    key={category.strCategory}
                                    value={category.strCategory}
                                >
                                    { category.strCategory }
                                </option>
                            ))
                        }
                    </select>
                </div>
                <div className="col-md-4">
                    <input 
                        type="submit"
                        className="btn btn-block btn-primary"
                        value="Find drink"
                    />
                </div>
            </div>
        </form>
     );
}
 
export default Form;